export default {
    general: {
        back: "Back",
        validate: "Validate",
        confirm: "Confirm",
        save: "Save",
        delete: "Delete",
        loading: "Loading",
        share: "Share",
        download: "Download",
        retry: "Retry",
        html5NotSupported: "Your browser does not support HTML5 video.",
        permissionError: "Permission error",
        motionPermissionRefused:
            "The AR view requires access to your devices's movements. Please restart your browser and grant access to request for motion sensor.",
        GCU: "Terms and conditions",
        serverError: "Server error",
        camera: "Camera",
        landscapeMessage: "Please hold your device in portrait mode",
        rgpdUrl: "https://ar-go.co/stqr-my-personal-information/",
        RGPDLinkText: "Privacy policy",
        or: "or",
        cancel: "Cancel"
    },
    rgpd: {
        popinTitle: "We need your agreement to go any further:",
        termsAndConditionsText:
            "I accept <a target='blank' href='https://ar-go.co/stqr-conditions-generales-dutilisation/'>terms and conditions</a> and <a target='blank' href='https://ar-go.co/stqr-my-personal-information/'>privacy policy</a>",
        shareEmailText:
            "I agree to share my account email with the issuer of this QR code, so that he can contact me for this experience only.",
        acceptAll: "Accept all",
        rejectAll: "Reject all",
        submit: "Validate",
        error: {
            termsAndConditionsCheckboxRequired:
                "You must accept terms and conditions and privacy policy to continue the experience."
        }
    },
    home: {
        record: "Save my video",
        edit: "Edit",
        changeBrowser: "Browser not supported",
        changeBrowserDetail:
            "Sorry, but the app cannot be used on this browser. Please open it on Chrome or Firefox on Android and Safari on iOS.",
        copyUrl: "Copy URL",
        adBannerTitle: "Don't miss the offer of the month!",
        adBannerText: "Are you interested in stqr? Contact us to find out more",
        adBannerUrl: "https://ar-go.co/stqr/#stqr-contact",
        leftCTATitle: "Contact",
        rightCTATitle: "Links",
        processingVideo: "Please wait, your video is being processed..."
    },
    ar: {
        firstPopin: "Place the marker on a flat surface facing you",
        secondPopin: "Click on the marker to start the animation"
    },
    optionalSignUp: {
        intro:
            "You'll be able to edit the videos related to your QR Codes on your <a href='https://admin.stqr.io' target='_blank'>stqr.io</a> account at any time.",
        createAccount: "Create a personal account",
        noSignUp: "Continue without subscription",
        warning: "Warning !",
        warningMessage:
            "You won't be able to come back to modify or delete your video once they will be uploaded.",
        recommended: "recommended"
    },
    signInUp: {
        introSignUp:
            "Sign up to add your video message. You'll be able to edit the videos related to your QR Codes on your <a href='https://admin.stqr.io' target='_blank'>stqr.io</a> account at any time.",
        signIn: "Sign in",
        emailAddress: "E-mail address",
        password: "Password",
        passwordConfirm: "Confirm password",
        createAccount: "Create an account",
        name: "Name",
        alreadyHaveAccount: "I already have an account",
        googleSignIn: "Sign in with Google",
        forgetPasswordTitle: "Forget password",
        forgetPasswordTutorial:
            "Please enter your email address, we will send you an email with a new password.",
        forgetPasswordSuccess: "E-mail sent",
        onSignUpPopinTitle: "Thank you for creating your stqr account",
        onSignUpPopinText:
            "An email with the link to access your account has been sent to you. You can edit your videos at any time by logging into your personal stqr account.",
        remindsMe:
            "I authorize the storage of a local cookie so that I won't have to log-in each time I use the service",
        notQrOwner: "Ce compte n'est pas propriétaire du message",
        ATHERR00_EMAIL: "Incorrect email format",
        ATHERR00_NAME: "Incorrect name format",
        ATHERR00_PWD: "Incorrect password",
        ATHERR00_INC: "Incorrect data",
        ATHERR01: "Incorrect data",
        ATHERR02: "Already existing account",
        ATHERR03: "User not found",
        ATHERR04: "This Google account doesn't have required permissions",
        INTERR0: "An error occured",
        notInDemo: "Unavailable feature in demo mode",
        pwdLength: "Password must be 10 to 12 characters",
        pwdNumberRequired: "Include one number",
        pwdUpperRequired: "Include upper and lower case characters",
        pwdNoSpace: "Not include spaces",
        pwdNoMatch: "Passwords do not match",
        "Network Error": "Error while trying to connect to the server",
        unknownError: "An error occured"
    },
    record: {
        unsupported: "Unsupported format",
        available: "Formats : mov, mp4, avi, mpg",
        videoTooBigTitle: "Too big video",
        videoTooBigText: "Your video must not exceed {maxSize}Mb ({currentSize}Mb now)",
        videoTooLongTitle: "Too long video",
        videoTooLongText: "Your video must not exceed {maxDuration} seconds",
        videoPickingText:
            "Click on the button to create or upload a video.<br/>No more than { maxDuration } seconds for an optimal experience."
    },
    upload: {
        uploading: "Sending video file",
        experienceCreating: "Your experience is being created",
        uploadError: "An error occured when uploading your video."
    },
    success: {
        done: "Done !",
        doneMultiVideo: "Your video was successfully sent",
        seeMyVideoAR: "Watch video in AR",
        seeMyVideoHome: "Watch video in fullscreen"
    },
    share: {
        openTitle: "Discover stqr, the video message that sticks everywhere",
        openText: "Demo",
        burnedTitle: "You have a video message"
    },
    desktop: {
        title: "You have a message !",
        tutorialNoMessage:
            "<b>Scan this QR code</b> with the camera of you phone to record a video message.",
        tutorial: "<b>Scan this QR code</b> with the camera of you phone to see the video message.",
        tutorial2: "Or open this link from your smartphone or tablet"
    },
    errors: {
        title: "Oops",
        qrcodeNotFoundTitle: "QR code not found",
        qrcodeNotFoundText: "Can't find the QR code... sorry.",
        serverErrorTitle: "Server error",
        serverErrorText: "Connection problem with our QR code server",
        networkErrorTitle: "Network error",
        networkErrorText: "Network connection problem. Some features might be unavailable",
        timeout: "Timeout",
        noGyro:
            "Your device appears to be incompatible with AR view. Unable to access device orientation. Please try again on another device.",
        videoConnectionProblems: "Video cannot be loaded"
    },
    report: {
        report: "Report",
        popinTitle: "Report",
        selectReason: "Please select a reason",
        step2Title: "Your report is anonymous",
        step2Subtitle:
            "Leave us your contact information if you wish to be informed of the outcome of this report.",
        step3Title: "Thank you",
        step3Subtitle: "Your report has been taken into account",
        step3Text: "We will proceed to its evalution as soon as possible",
        keepMeInformed: "I want to be informed",
        lastName: "Name",
        firstName: "First name",
        email: "Email",
        message: "Message",
        close: "Close",
        bannedVideoMessage: "This video was removed following a report",
        reasons: {
            HATE: "Hate speech or symbols",
            NUDITY_SEX: "Nudity or sexual activity",
            ANIMAL_CRUELTY: "Animal cruelty",
            SUICIDE_SELF_INJURY: "Suicide or self-injury",
            BULLYING: "Bullying or harassment",
            FAKE_NEWS: "False information",
            VIOLENCE: "Violence or dangerous organizations",
            SCAM: "Scam or fraud",
            SALE_ILLEGAL: "Sale of illegal or regulated goods",
            INTELLECTUAL_VIOLATION: "Intellectual property violation",
            CHILDREN_SAFETY: "Children's safety"
        },
        errors: {
            invalidEmail: "Invalid e-mail address",
            emailFieldRequiredField: "The e-mail field is mandatory",
            unknownError: "An unknown error occured, please try again",
            EEXISTS: "This content has already been reported"
        }
    },
    reply: {
        title: "Enter your answer. You can indicate your first and last name in your message",
        btnReply: "Reply to video",
        firstName: "First name",
        lastName: "Last name",
        textAreaPlaceholder: "Enter text",
        replySent: "Your reply successfully sent!",
        sending: "Sending..."
    },
    inactive: {
        landingPageText: "This experience has been deactivated by its owner",
        banned: "This experience has been banned by its owner"
    },
    personalDataForm: {
        title: "Données personnelles",
        firstNameLabel: "First name",
        lastNameLabel: "Last name",
        emailLabel: "Email",
        phoneLabel: "Phone",
        errors: {
            fieldRequired: "This field is required",
            fieldValueIncorrect: "Incorrect field value",
            videoAgreement:
                "You must grant permission to use your video for promotional purposes in order to continue the experience."
        }
    },
    errorsUid: {
        STQRAPI_ERR_INTERNAL: "Internal error",
        STQRAPI_ERR_NOT_IMPLEMENTED: "Not implemented yet",
        STQRAPI_ERR_OBJECT_NOT_FOUND: "Object not found",
        STQRAPI_ERR_INVALID_ID: "Invalid ID",
        STQRAPI_ERR_CANT_GENERATE_TOKEN:"Can't generate token",
        STQRAPI_ERR_WRONG_EMAIL_OR_PASSWORD: "Wrong email or password",
        STQRAPI_ERR_MIN_TOKEN_TTL: "Token's TTL can't be less than 1 second",
        STQRAPI_ERR_MAX_NORMAL_TOKEN_TTL: "Normal token's TTL can't be more than 7 days",
        STQRAPI_ERR_MAX_SERVICE_TOKEN_TTL: "Service token's TTL can't be more than 10 years",
        STQRAPI_ERR_REQUIRED_PARAMETER: "[%s] is required parameter",
        STQRAPI_ERR_INVALID_PARAMETER_VALUE: "Invalid value for [%s] parameter",
        STQRAPI_ERR_INVALID_TOKEN: "Invalid token",
        STQRAPI_ERR_INVALID_TOKEN_PROVIDER: "Invalid token provider",
        STQRAPI_ERR_EMPTY_TOKEN: "Empty token",
        STQRAPI_ERR_CANT_GET_USER_FROM_TOKEN: "Can't get STQR user from token",
        STQRAPI_ERR_NO_PERMISSIONS: "You have no permissions to do this",
        STQRAPI_ERR_PARENT_CLIENT_IS_NOT_MULTI: "Parent organization is not multiorganization",
        STQRAPI_ERR_INVALID_ROLE: "Invalid role",
        STQRAPI_ERR_INSUFFICIENT_RIGHTS: "Insufficient rights",
        STQRAPI_ERR_INVALID_PASSWORD: "Invalid password. Password has to be at least 10 symbols long (English letters, numbers and any of special symbols) without spaces. Password should have at least one upper case letter.Password should have at least one number. Password should have at least one special symbol:~,!,@,#,$,%,^,&,*,_,+.",
        STQRAPI_ERR_INVALID_CLIENT_ID: "Invalid organization_id value",
        STQRAPI_ERR_CANT_SEND_PASSWORD_RESET_LINK: "Can't send password reset link",
        STQRAPI_ERR_PASSWORD_RESET_LINK_INVALID: "Password reset link is invalid",
        STQRAPI_ERR_PASSWORD_RESET_LINK_EXPIRED: "Password reset link is expired",
        STQRAPI_ERR_USERS_QUOTA_REACHED: "Users quota reached",
        STQRAPI_ERR_NO_RIGHTS_TO_CREATE_SERVICE_TOKEN: "You have no rights to create a service token",
        STQRAPI_ERR_SESSION_EXPIRED: "Session expired",
        STQRAPI_ERR_VALUE_TOO_BIG: "[%s] is too big. [%d] bytes allowed",
        STQRAPI_ERR_VALUE_NOT_AVAILABLE: "[%s] value of [%s] parameter is not available to be set",
        STQRAPI_ERR_CANT_DELETE_SYSTEM_USER: "System user can not be deleted",
        STQRAPI_ERR_SSO_MODE_ENABLED: "This operation is not allowed when sso mode is enabled",
        STQRAPI_ERR_INVALID_EMAIL: "Invalid Email. Allowed symbols: [a-zA-Z0-9]+._-@'.",
        STQRAPI_ERR_ORGANIZATION_CANNOT_BE_DELETED_HAS_CHILDREN: "Organization with id [%d] cannot be deleted because it has children",
        STQRAPI_ERR_ORGANIZATION_CANNOT_BE_DELETED_HAS_USERS: "Organization with id [%d] cannot be deleted because it has users",
        STQRAPI_ERR_USER_ALREADY_EXISTS: "User with specified email already exists in this application",
        STQRAPI_ERR_FILE_DOES_NOT_EXIST: "Provided file does not exist",
        STQRAPI_ERR_GUEST_ALREADY_EXISTS: "Guest with specified email already exists in this application",
        STQRAPI_ERR_WRONG_ACTIVATION_CODE: "Wrong activation code",
        STQRAPI_ERR_ACTIVATION_CODE_EXPIRED: "Activation code expired",
        STQRAPI_ERR_CANT_SEND_GUEST_ACTIVATION_CODE: "Can't send guest activation code",
        STQRAPI_ERR_CANT_GET_GUEST_FROM_TOKEN: "Can't get guest user from token",
        STQRAPI_ERR_NO_FILES_TO_PRESIGN: "No files to presign. Please provide over 'file[]' or 'files' parameter.",
        STQRAPI_ERR_NO_RIGHTS_TO_SET_IS_SERVICE_TEMPLATE_FLAG: "You have no rights to set is_service_template flag",
        STQRAPI_ERR_TEMPLATE_USED_IN_PROJECTS: "Template is used in projects",
        STQRAPI_ERR_SERVICE_TEMPLATE_CANNOT_BE_UPDATED: "Service template cannot be updated",
        STQRAPI_ERR_SERVICE_TEMPLATE_CANNOT_BE_DELETED: "Service template cannot be deleted",
        STQRAPI_ERR_INVALID_PROJECT_TYPE: "Invalid project type",
        STQRAPI_ERR_INVALID_PROJECT_AUTH_TYPE: "Invalid project auth type",
        STQRAPI_ERR_INVALID_PROJECT_VIDEO_AGREEMENT_TYPE: "Invalid project video agreement type",
        STQRAPI_ERR_INVALID_PROJECT_SCHEDULED_DATES: "Invalid project scheduled dates",
        STQRAPI_ERR_PROJECT_HAS_SHORTLINK_BATCHES: "Project has shortlink batches",
        STQRAPI_ERR_INVALID_SHORTLINK_REPORT_TYPE: "Invalid shortlink report type",
        STQRAPI_ERR_INVALID_SHORTLINK_REPORT_STATUS: "Invalid shortlink report status",
        STQRAPI_ERR_SHORTLINK_ALREADY_HAS_BURNS: "Shortlink already has burns",
        STQRAPI_ERR_SHORTLINK_BATCH_AMOUNT_SHOULD_BE_POSITIVE: "Shortlink batch amount should be positive",
        STQRAPI_ERR_GUEST_ALREADY_ACTIVATED: "Guest already activated",
        STQRAPI_ERR_USER_IS_NOT_ACTIVE: "User is not active",
        STQRAPI_ERR_PROJECT_REQUIRES_AUTH: "Project requires authorization",
        STQRAPI_ERR_SHORTLINK_BURN_VIDEO_TOO_LONG: "Video is too long",
        STQRAPI_ERR_PROJECT_HAS_NO_PUBLIC_STATS: "Project has no public statistics",
        STQRAPI_ERR_PROJECT_HAS_NO_PUBLIC_BURNS_DATA: "Project has no public burns data",
        STQRAPI_ERR_TRANSCODER_CANNOT_PROCES_VIDEO: "Transcoder cannot process video",
        STQRAPI_ERR_TRANSCODER_FILE_ON_EXTERNAL_STORAGE: "Transcoder cannot process file on external storage",
        STQRAPI_ERR_LOCKED_TEMPLATE_CANNOT_BE_UPDATED: "Locked template cannot be updated",
        STQRAPI_ERR_PROJECT_IS_NOT_COMMENTABLE: "Project is not commentable",
        STQRAPI_ERR_SHORTLINK_IS_BANNED: "Shortlink is banned"
    }
};
